/**
 * Chart Factory
 * Routes chart creation to appropriate chart type functions
 *
 * Only the cards that actually OPEN this dialog are routed here. Phase 1H
 * removed the branches for totalCost, fixedCost, transportCost, variableCost,
 * capacityUtil and totalDemand, with the three builders they were the only
 * callers of (createCostBreakdownChart, createCostComparisonChart,
 * createUtilizationGaugeChart, createDemandChart): `openStatDetail` emits a
 * `click:*` event and returns for every one of those cards, so the dialog — and
 * therefore the chart — was unreachable. Reviving one means routing its card
 * here instead of to its own analysis dialog.
 */

import { createFacilitiesChart } from './dataCharts.js'
import { createServiceLevelChart } from './dataCharts.js'
import { createCapacityChart } from './dataCharts.js'
import { createGenericChart } from './dataCharts.js'

/**
 * Create chart based on card type
 * @param {CanvasRenderingContext2D} ctx - Canvas context
 * @param {Object} card - Card object
 * @param {Object} chartData - Data needed for charts (costs, facilities, etc.)
 * @returns {Chart} Chart.js instance
 */
export function createChart(ctx, card, chartData) {
  switch (card.id) {
    case 'totalFacilities':
      return createFacilitiesChart(ctx, card, chartData)
    case 'serviceLevel':
      return createServiceLevelChart(ctx, card, chartData)
    case 'spareCapacity':
      return createCapacityChart(ctx, card, chartData)
    default:
      return createGenericChart(ctx, card, chartData)
  }
}
